module.exports = __webpack_public_path__ + "static/images/styles/images/nations/sweden-cn.b043adf0.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/sweden-cn.png
// module id = 3671
// module chunks = 11